"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ionicons = void 0;
var Ionicons;
(function (Ionicons) {
    Ionicons["ADD"] = "add";
    Ionicons["ADD_CIRCLE"] = "add-circle";
    Ionicons["AIRPLANE"] = "airplane";
    Ionicons["ALARM"] = "alarm";
    Ionicons["ALBUMS"] = "albums";
    Ionicons["ALERT"] = "alert";
    Ionicons["ALERT_CIRCLE"] = "alert-circle";
    Ionicons["AMERICAN_FOOTBALL"] = "american-football";
    Ionicons["ANALYTICS"] = "analytics";
    Ionicons["APERTURE"] = "aperture";
    Ionicons["APPS"] = "apps";
    Ionicons["ARCHIVE"] = "archive";
    Ionicons["ARROW_BACK"] = "arrow-back";
    Ionicons["ARROW_BACK_CIRCLE"] = "arrow-back-circle";
    Ionicons["ARROW_DOWN"] = "arrow-down";
    Ionicons["ARROW_DOWN_CIRCLE"] = "arrow-down-circle";
    Ionicons["ARROW_FORWARD"] = "arrow-forward";
    Ionicons["ARROW_FORWARD_CIRCLE"] = "arrow-forward-circle";
    Ionicons["ARROW_REDO"] = "arrow-redo";
    Ionicons["ARROW_REDO_CIRCLE"] = "arrow-redo-circle";
    Ionicons["ARROW_UNDO"] = "arrow-undo";
    Ionicons["ARROW_UNDO_CIRCLE"] = "arrow-undo-circle";
    Ionicons["ARROW_UP"] = "arrow-up";
    Ionicons["ARROW_UP_CIRCLE"] = "arrow-up-circle";
    Ionicons["AT"] = "at";
    Ionicons["AT_CIRCLE"] = "at-circle";
    Ionicons["ATTACH"] = "attach";
    Ionicons["BACKSPACE"] = "backspace";
    Ionicons["BANDAGE"] = "bandage";
    Ionicons["BAR_CHART"] = "bar-chart";
    Ionicons["BARBELL"] = "barbell";
    Ionicons["BARCODE"] = "barcode";
    Ionicons["BASEBALL"] = "baseball";
    Ionicons["BASKET"] = "basket";
    Ionicons["BASKETBALL"] = "basketball";
    Ionicons["BATTERY_CHARGING"] = "battery-charging";
    Ionicons["BATTERY_DEAD"] = "battery-dead";
    Ionicons["BATTERY_FULL"] = "battery-full";
    Ionicons["BATTERY_HALF"] = "battery-half";
    Ionicons["BEAKER"] = "beaker";
    Ionicons["BED"] = "bed";
    Ionicons["BEER"] = "beer";
    Ionicons["BICYCLE"] = "bicycle";
    Ionicons["BLUETOOTH"] = "bluetooth";
    Ionicons["BOAT"] = "boat";
    Ionicons["BODY"] = "body";
    Ionicons["BONFIRE"] = "bonfire";
    Ionicons["BOOK"] = "book";
    Ionicons["BOOKMARK"] = "bookmark";
    Ionicons["BOOKMARKS"] = "bookmarks";
    Ionicons["BRIEFCASE"] = "briefcase";
    Ionicons["BROWSERS"] = "browsers";
    Ionicons["BRUSH"] = "brush";
    Ionicons["BUG"] = "bug";
    Ionicons["BUILD"] = "build";
    Ionicons["BULB"] = "bulb";
    Ionicons["BUS"] = "bus";
    Ionicons["BUSINESS"] = "business";
    Ionicons["CAFE"] = "cafe";
    Ionicons["CALCULATOR"] = "calculator";
    Ionicons["CALENDAR"] = "calendar";
    Ionicons["CALL"] = "call";
    Ionicons["CAMERA"] = "camera";
    Ionicons["CAMERA_REVERSE"] = "camera-reverse";
    Ionicons["CAR"] = "car";
    Ionicons["CAR_SPORT"] = "car-sport";
    Ionicons["CARD"] = "card";
    Ionicons["CARET_BACK"] = "caret-back";
    Ionicons["CARET_BACK_CIRCLE"] = "caret-back-circle";
    Ionicons["CARET_DOWN"] = "caret-down";
    Ionicons["CARET_DOWN_CIRCLE"] = "caret-down-circle";
    Ionicons["CARET_FORWARD"] = "caret-forward";
    Ionicons["CARET_FORWARD_CIRCLE"] = "caret-forward-circle";
    Ionicons["CARET_UP"] = "caret-up";
    Ionicons["CARET_UP_CIRCLE"] = "caret-up-circle";
    Ionicons["CART"] = "cart";
    Ionicons["CASH"] = "cash";
    Ionicons["CELLULAR"] = "cellular";
    Ionicons["CHATBOX"] = "chatbox";
    Ionicons["CHATBOX_ELLIPSES"] = "chatbox-ellipses";
    Ionicons["CHATBUBBLE"] = "chatbubble";
    Ionicons["CHATBUBBLE_ELLIPSES"] = "chatbubble-ellipses";
    Ionicons["CHATBUBBLES"] = "chatbubbles";
    Ionicons["CHECKBOX"] = "checkbox";
    Ionicons["CHECKMARK"] = "checkmark";
    Ionicons["CHECKMARK_CIRCLE"] = "checkmark-circle";
    Ionicons["CHECKMARK_DONE"] = "checkmark-done";
    Ionicons["CHECKMARK_DONE_CIRCLE"] = "checkmark-done-circle";
    Ionicons["CHEVRON_BACK"] = "chevron-back";
    Ionicons["CHEVRON_BACK_CIRCLE"] = "chevron-back-circle";
    Ionicons["CHEVRON_DOWN"] = "chevron-down";
    Ionicons["CHEVRON_DOWN_CIRCLE"] = "chevron-down-circle";
    Ionicons["CHEVRON_FORWARD"] = "chevron-forward";
    Ionicons["CHEVRON_FORWARD_CIRCLE"] = "chevron-forward-circle";
    Ionicons["CHEVRON_UP"] = "chevron-up";
    Ionicons["CHEVRON_UP_CIRCLE"] = "chevron-up-circle";
    Ionicons["CLIPBOARD"] = "clipboard";
    Ionicons["CLOSE"] = "close";
    Ionicons["CLOSE_CIRCLE"] = "close-circle";
    Ionicons["CLOUD"] = "cloud";
    Ionicons["CLOUD_CIRCLE"] = "cloud-circle";
    Ionicons["CLOUD_DONE"] = "cloud-done";
    Ionicons["CLOUD_DOWNLOAD"] = "cloud-download";
    Ionicons["CLOUD_OFFLINE"] = "cloud-offline";
    Ionicons["CLOUD_UPLOAD"] = "cloud-upload";
    Ionicons["CLOUDY"] = "cloudy";
    Ionicons["CLOUDY_NIGHT"] = "cloudy-night";
    Ionicons["CODE"] = "code";
    Ionicons["CODE_DOWNLOAD"] = "code-download";
    Ionicons["CODE_SLASH"] = "code-slash";
    Ionicons["CODE_WORKING"] = "code-working";
    Ionicons["COG"] = "cog";
    Ionicons["COLOR_FILL"] = "color-fill";
    Ionicons["COLOR_FILTER"] = "color-filter";
    Ionicons["COLOR_PALETTE"] = "color-palette";
    Ionicons["COLOR_WAND"] = "color-wand";
    Ionicons["COMPASS"] = "compass";
    Ionicons["CONSTRUCT"] = "construct";
    Ionicons["CONTRACT"] = "contract";
    Ionicons["CONTRAST"] = "contrast";
    Ionicons["COPY"] = "copy";
    Ionicons["CREATE"] = "create";
    Ionicons["CROP"] = "crop";
    Ionicons["CUBE"] = "cube";
    Ionicons["CUT"] = "cut";
    Ionicons["DESKTOP"] = "desktop";
    Ionicons["DISC"] = "disc";
    Ionicons["DOCUMENT"] = "document";
    Ionicons["DOCUMENT_ATTACH"] = "document-attach";
    Ionicons["DOCUMENT_TEXT"] = "document-text";
    Ionicons["DOCUMENTS"] = "documents";
    Ionicons["DOWNLOAD"] = "download";
    Ionicons["DUPLICATE"] = "duplicate";
    Ionicons["EAR"] = "ear";
    Ionicons["EARTH"] = "earth";
    Ionicons["EASEL"] = "easel";
    Ionicons["EGG"] = "egg";
    Ionicons["ELLIPSE"] = "ellipse";
    Ionicons["ELLIPSIS_HORIZONTAL"] = "ellipsis-horizontal";
    Ionicons["ELLIPSIS_HORIZONTAL_CIRCLE"] = "ellipsis-horizontal-circle";
    Ionicons["ELLIPSIS_VERTICAL"] = "ellipsis-vertical";
    Ionicons["ELLIPSIS_VERTICAL_CIRCLE"] = "ellipsis-vertical-circle";
    Ionicons["ENTER"] = "enter";
    Ionicons["EXIT"] = "exit";
    Ionicons["EXPAND"] = "expand";
    Ionicons["EYE"] = "eye";
    Ionicons["EYE_OFF"] = "eye-off";
    Ionicons["EYEDROP"] = "eyedrop";
    Ionicons["FAST_FOOD"] = "fast-food";
    Ionicons["FEMALE"] = "female";
    Ionicons["FILE_TRAY"] = "file-tray";
    Ionicons["FILE_TRAY_FULL"] = "file-tray-full";
    Ionicons["FILE_TRAY_STACKED"] = "file-tray-stacked";
    Ionicons["FILM"] = "film";
    Ionicons["FILTER"] = "filter";
    Ionicons["FINGER_PRINT"] = "finger-print";
    Ionicons["FITNESS"] = "fitness";
    Ionicons["FLAG"] = "flag";
    Ionicons["FLAME"] = "flame";
    Ionicons["FLASH"] = "flash";
    Ionicons["FLASH_OFF"] = "flash-off";
    Ionicons["FLASHLIGHT"] = "flashlight";
    Ionicons["FLASK"] = "flask";
    Ionicons["FLOWER"] = "flower";
    Ionicons["FOLDER"] = "folder";
    Ionicons["FOLDER_OPEN"] = "folder-open";
    Ionicons["FOOTBALL"] = "football";
    Ionicons["FUNNEL"] = "funnel";
    Ionicons["GAME_CONTROLLER"] = "game-controller";
    Ionicons["GIFT"] = "gift";
    Ionicons["GIT_BRANCH"] = "git-branch";
    Ionicons["GIT_COMMIT"] = "git-commit";
    Ionicons["GIT_COMPARE"] = "git-compare";
    Ionicons["GIT_MERGE"] = "git-merge";
    Ionicons["GIT_NETWORK"] = "git-network";
    Ionicons["GIT_PULL_REQUEST"] = "git-pull-request";
    Ionicons["GLASSES"] = "glasses";
    Ionicons["GLOBE"] = "globe";
    Ionicons["GOLF"] = "golf";
    Ionicons["GRID"] = "grid";
    Ionicons["HAMMER"] = "hammer";
    Ionicons["HAND_LEFT"] = "hand-left";
    Ionicons["HAND_RIGHT"] = "hand-right";
    Ionicons["HAPPY"] = "happy";
    Ionicons["HARDWARE_CHIP"] = "hardware-chip";
    Ionicons["HEADSET"] = "headset";
    Ionicons["HEART"] = "heart";
    Ionicons["HEART_CIRCLE"] = "heart-circle";
    Ionicons["HEART_DISLIKE"] = "heart-dislike";
    Ionicons["HEART_DISLIKE_CIRCLE"] = "heart-dislike-circle";
    Ionicons["HEART_HALF"] = "heart-half";
    Ionicons["HELP"] = "help";
    Ionicons["HELP_BUOY"] = "help-buoy";
    Ionicons["HELP_CIRCLE"] = "help-circle";
    Ionicons["HOME"] = "home";
    Ionicons["HOURGLASS"] = "hourglass";
    Ionicons["ICE_CREAM"] = "ice-cream";
    Ionicons["IMAGE"] = "image";
    Ionicons["IMAGES"] = "images";
    Ionicons["INFINITE"] = "infinite";
    Ionicons["INFORMATION"] = "information";
    Ionicons["INFORMATION_CIRCLE"] = "information-circle";
    Ionicons["JOURNAL"] = "journal";
    Ionicons["KEY"] = "key";
    Ionicons["KEYPAD"] = "keypad";
    Ionicons["LANGUAGE"] = "language";
    Ionicons["LAPTOP"] = "laptop";
    Ionicons["LAYERS"] = "layers";
    Ionicons["LEAF"] = "leaf";
    Ionicons["LIBRARY"] = "library";
    Ionicons["LINK"] = "link";
    Ionicons["LIST"] = "list";
    Ionicons["LIST_CIRCLE"] = "list-circle";
    Ionicons["LOCATE"] = "locate";
    Ionicons["LOCATION"] = "location";
    Ionicons["LOCK_CLOSED"] = "lock-closed";
    Ionicons["LOCK_OPEN"] = "lock-open";
    Ionicons["LOG_IN"] = "log-in";
    Ionicons["LOG_OUT"] = "log-out";
    Ionicons["LOGO_AMAZON"] = "logo-amazon";
    Ionicons["LOGO_AMPLIFY"] = "logo-amplify";
    Ionicons["LOGO_ANDROID"] = "logo-android";
    Ionicons["LOGO_ANGULAR"] = "logo-angular";
    Ionicons["LOGO_APPLE"] = "logo-apple";
    Ionicons["LOGO_APPLE_APPSTORE"] = "logo-apple-appstore";
    Ionicons["LOGO_BITBUCKET"] = "logo-bitbucket";
    Ionicons["LOGO_BITCOIN"] = "logo-bitcoin";
    Ionicons["LOGO_BUFFER"] = "logo-buffer";
    Ionicons["LOGO_CAPACITOR"] = "logo-capacitor";
    Ionicons["LOGO_CHROME"] = "logo-chrome";
    Ionicons["LOGO_CLOSED_CAPTIONING"] = "logo-closed-captioning";
    Ionicons["LOGO_CODEPEN"] = "logo-codepen";
    Ionicons["LOGO_CSS3"] = "logo-css3";
    Ionicons["LOGO_DESIGNERNEWS"] = "logo-designernews";
    Ionicons["LOGO_DRIBBBLE"] = "logo-dribbble";
    Ionicons["LOGO_DROPBOX"] = "logo-dropbox";
    Ionicons["LOGO_EDGE"] = "logo-edge";
    Ionicons["LOGO_ELECTRON"] = "logo-electron";
    Ionicons["LOGO_EURO"] = "logo-euro";
    Ionicons["LOGO_FACEBOOK"] = "logo-facebook";
    Ionicons["LOGO_FIREBASE"] = "logo-firebase";
    Ionicons["LOGO_FIREFOX"] = "logo-firefox";
    Ionicons["LOGO_FLICKR"] = "logo-flickr";
    Ionicons["LOGO_FOURSQUARE"] = "logo-foursquare";
    Ionicons["LOGO_GITHUB"] = "logo-github";
    Ionicons["LOGO_GOOGLE"] = "logo-google";
    Ionicons["LOGO_GOOGLE_PLAYSTORE"] = "logo-google-playstore";
    Ionicons["LOGO_HACKERNEWS"] = "logo-hackernews";
    Ionicons["LOGO_HTML5"] = "logo-html5";
    Ionicons["LOGO_INSTAGRAM"] = "logo-instagram";
    Ionicons["LOGO_IONIC"] = "logo-ionic";
    Ionicons["LOGO_IONITRON"] = "logo-ionitron";
    Ionicons["LOGO_JAVASCRIPT"] = "logo-javascript";
    Ionicons["LOGO_LARAVEL"] = "logo-laravel";
    Ionicons["LOGO_LINKEDIN"] = "logo-linkedin";
    Ionicons["LOGO_MARKDOWN"] = "logo-markdown";
    Ionicons["LOGO_NO_SMOKING"] = "logo-no-smoking";
    Ionicons["LOGO_NODEJS"] = "logo-nodejs";
    Ionicons["LOGO_NPM"] = "logo-npm";
    Ionicons["LOGO_OCTOCAT"] = "logo-octocat";
    Ionicons["LOGO_PINTEREST"] = "logo-pinterest";
    Ionicons["LOGO_PLAYSTATION"] = "logo-playstation";
    Ionicons["LOGO_PWA"] = "logo-pwa";
    Ionicons["LOGO_PYTHON"] = "logo-python";
    Ionicons["LOGO_REACT"] = "logo-react";
    Ionicons["LOGO_REDDIT"] = "logo-reddit";
    Ionicons["LOGO_RSS"] = "logo-rss";
    Ionicons["LOGO_SASS"] = "logo-sass";
    Ionicons["LOGO_SKYPE"] = "logo-skype";
    Ionicons["LOGO_SLACK"] = "logo-slack";
    Ionicons["LOGO_SNAPCHAT"] = "logo-snapchat";
    Ionicons["LOGO_STACKOVERFLOW"] = "logo-stackoverflow";
    Ionicons["LOGO_STEAM"] = "logo-steam";
    Ionicons["LOGO_STENCIL"] = "logo-stencil";
    Ionicons["LOGO_TUMBLR"] = "logo-tumblr";
    Ionicons["LOGO_TUX"] = "logo-tux";
    Ionicons["LOGO_TWITCH"] = "logo-twitch";
    Ionicons["LOGO_TWITTER"] = "logo-twitter";
    Ionicons["LOGO_USD"] = "logo-usd";
    Ionicons["LOGO_VIMEO"] = "logo-vimeo";
    Ionicons["LOGO_VK"] = "logo-vk";
    Ionicons["LOGO_VUE"] = "logo-vue";
    Ionicons["LOGO_WEB_COMPONENT"] = "logo-web-component";
    Ionicons["LOGO_WHATSAPP"] = "logo-whatsapp";
    Ionicons["LOGO_WINDOWS"] = "logo-windows";
    Ionicons["LOGO_WORDPRESS"] = "logo-wordpress";
    Ionicons["LOGO_XBOX"] = "logo-xbox";
    Ionicons["LOGO_XING"] = "logo-xing";
    Ionicons["LOGO_YAHOO"] = "logo-yahoo";
    Ionicons["LOGO_YEN"] = "logo-yen";
    Ionicons["LOGO_YOUTUBE"] = "logo-youtube";
    Ionicons["MAGNET"] = "magnet";
    Ionicons["MAIL"] = "mail";
    Ionicons["MAIL_OPEN"] = "mail-open";
    Ionicons["MAIL_UNREAD"] = "mail-unread";
    Ionicons["MALE"] = "male";
    Ionicons["MALE_FEMALE"] = "male-female";
    Ionicons["MAN"] = "man";
    Ionicons["MAP"] = "map";
    Ionicons["MEDAL"] = "medal";
    Ionicons["MEDICAL"] = "medical";
    Ionicons["MEDKIT"] = "medkit";
    Ionicons["MEGAPHONE"] = "megaphone";
    Ionicons["MENU"] = "menu";
    Ionicons["MIC"] = "mic";
    Ionicons["MIC_CIRCLE"] = "mic-circle";
    Ionicons["MIC_OFF"] = "mic-off";
    Ionicons["MIC_OFF_CIRCLE"] = "mic-off-circle";
    Ionicons["MOON"] = "moon";
    Ionicons["MOVE"] = "move";
    Ionicons["MUSICAL_NOTE"] = "musical-note";
    Ionicons["MUSICAL_NOTES"] = "musical-notes";
    Ionicons["NAVIGATE"] = "navigate";
    Ionicons["NAVIGATE_CIRCLE"] = "navigate-circle";
    Ionicons["NEWSPAPER"] = "newspaper";
    Ionicons["NOTIFICATIONS"] = "notifications";
    Ionicons["NOTIFICATIONS_CIRCLE"] = "notifications-circle";
    Ionicons["NOTIFICATIONS_OFF"] = "notifications-off";
    Ionicons["NOTIFICATIONS_OFF_CIRCLE"] = "notifications-off-circle";
    Ionicons["NUCLEAR"] = "nuclear";
    Ionicons["NUTRITION"] = "nutrition";
    Ionicons["OPEN"] = "open";
    Ionicons["OPTIONS"] = "options";
    Ionicons["PAPER_PLANE"] = "paper-plane";
    Ionicons["PARTLY_SUNNY"] = "partly-sunny";
    Ionicons["PAUSE"] = "pause";
    Ionicons["PAUSE_CIRCLE"] = "pause-circle";
    Ionicons["PAW"] = "paw";
    Ionicons["PENCIL"] = "pencil";
    Ionicons["PEOPLE"] = "people";
    Ionicons["PEOPLE_CIRCLE"] = "people-circle";
    Ionicons["PERSON"] = "person";
    Ionicons["PERSON_ADD"] = "person-add";
    Ionicons["PERSON_CIRCLE"] = "person-circle";
    Ionicons["PERSON_REMOVE"] = "person-remove";
    Ionicons["PHONE_LANDSCAPE"] = "phone-landscape";
    Ionicons["PHONE_PORTRAIT"] = "phone-portrait";
    Ionicons["PIE_CHART"] = "pie-chart";
    Ionicons["PIN"] = "pin";
    Ionicons["PINT"] = "pint";
    Ionicons["PIZZA"] = "pizza";
    Ionicons["PLANET"] = "planet";
    Ionicons["PLAY"] = "play";
    Ionicons["PLAY_BACK"] = "play-back";
    Ionicons["PLAY_BACK_CIRCLE"] = "play-back-circle";
    Ionicons["PLAY_CIRCLE"] = "play-circle";
    Ionicons["PLAY_FORWARD"] = "play-forward";
    Ionicons["PLAY_FORWARD_CIRCLE"] = "play-forward-circle";
    Ionicons["PLAY_SKIP_BACK"] = "play-skip-back";
    Ionicons["PLAY_SKIP_BACK_CIRCLE"] = "play-skip-back-circle";
    Ionicons["PLAY_SKIP_FORWARD"] = "play-skip-forward";
    Ionicons["PLAY_SKIP_FORWARD_CIRCLE"] = "play-skip-forward-circle";
    Ionicons["PODIUM"] = "podium";
    Ionicons["POWER"] = "power";
    Ionicons["PRICETAG"] = "pricetag";
    Ionicons["PRICETAGS"] = "pricetags";
    Ionicons["PRINT"] = "print";
    Ionicons["PULSE"] = "pulse";
    Ionicons["PUSH"] = "push";
    Ionicons["QR_CODE"] = "qr-code";
    Ionicons["RADIO"] = "radio";
    Ionicons["RADIO_BUTTON_OFF"] = "radio-button-off";
    Ionicons["RADIO_BUTTON_ON"] = "radio-button-on";
    Ionicons["RAINY"] = "rainy";
    Ionicons["READER"] = "reader";
    Ionicons["RECEIPT"] = "receipt";
    Ionicons["RECORDING"] = "recording";
    Ionicons["REFRESH"] = "refresh";
    Ionicons["REFRESH_CIRCLE"] = "refresh-circle";
    Ionicons["RELOAD"] = "reload";
    Ionicons["RELOAD_CIRCLE"] = "reload-circle";
    Ionicons["REMOVE"] = "remove";
    Ionicons["REMOVE_CIRCLE"] = "remove-circle";
    Ionicons["REORDER_FOUR"] = "reorder-four";
    Ionicons["REORDER_THREE"] = "reorder-three";
    Ionicons["REORDER_TWO"] = "reorder-two";
    Ionicons["REPEAT"] = "repeat";
    Ionicons["RESIZE"] = "resize";
    Ionicons["RESTAURANT"] = "restaurant";
    Ionicons["RETURN_DOWN_BACK"] = "return-down-back";
    Ionicons["RETURN_DOWN_FORWARD"] = "return-down-forward";
    Ionicons["RETURN_UP_BACK"] = "return-up-back";
    Ionicons["RETURN_UP_FORWARD"] = "return-up-forward";
    Ionicons["RIBBON"] = "ribbon";
    Ionicons["ROCKET"] = "rocket";
    Ionicons["ROSE"] = "rose";
    Ionicons["SAD"] = "sad";
    Ionicons["SAVE"] = "save";
    Ionicons["SCAN"] = "scan";
    Ionicons["SCAN_CIRCLE"] = "scan-circle";
    Ionicons["SCHOOL"] = "school";
    Ionicons["SEARCH"] = "search";
    Ionicons["SEARCH_CIRCLE"] = "search-circle";
    Ionicons["SEND"] = "send";
    Ionicons["SERVER"] = "server";
    Ionicons["SETTINGS"] = "settings";
    Ionicons["SHAPES"] = "shapes";
    Ionicons["SHARE"] = "share";
    Ionicons["SHARE_SOCIAL"] = "share-social";
    Ionicons["SHIELD"] = "shield";
    Ionicons["SHIELD_CHECKMARK"] = "shield-checkmark";
    Ionicons["SHIRT"] = "shirt";
    Ionicons["SHUFFLE"] = "shuffle";
    Ionicons["SKULL"] = "skull";
    Ionicons["SNOW"] = "snow";
    Ionicons["SPEEDOMETER"] = "speedometer";
    Ionicons["SQUARE"] = "square";
    Ionicons["STAR"] = "star";
    Ionicons["STAR_HALF"] = "star-half";
    Ionicons["STATS_CHART"] = "stats-chart";
    Ionicons["STOP"] = "stop";
    Ionicons["STOP_CIRCLE"] = "stop-circle";
    Ionicons["STOPWATCH"] = "stopwatch";
    Ionicons["SUBWAY"] = "subway";
    Ionicons["SUNNY"] = "sunny";
    Ionicons["SWAP_HORIZONTAL"] = "swap-horizontal";
    Ionicons["SWAP_VERTICAL"] = "swap-vertical";
    Ionicons["SYNC"] = "sync";
    Ionicons["SYNC_CIRCLE"] = "sync-circle";
    Ionicons["TABLET_LANDSCAPE"] = "tablet-landscape";
    Ionicons["TABLET_PORTRAIT"] = "tablet-portrait";
    Ionicons["TENNISBALL"] = "tennisball";
    Ionicons["TERMINAL"] = "terminal";
    Ionicons["TEXT"] = "text";
    Ionicons["THERMOMETER"] = "thermometer";
    Ionicons["THUMBS_DOWN"] = "thumbs-down";
    Ionicons["THUMBS_UP"] = "thumbs-up";
    Ionicons["THUNDERSTORM"] = "thunderstorm";
    Ionicons["TIME"] = "time";
    Ionicons["TIMER"] = "timer";
    Ionicons["TODAY"] = "today";
    Ionicons["TOGGLE"] = "toggle";
    Ionicons["TRAIL_SIGN"] = "trail-sign";
    Ionicons["TRAIN"] = "train";
    Ionicons["TRANSGENDER"] = "transgender";
    Ionicons["TRASH"] = "trash";
    Ionicons["TRASH_BIN"] = "trash-bin";
    Ionicons["TRENDING_DOWN"] = "trending-down";
    Ionicons["TRENDING_UP"] = "trending-up";
    Ionicons["TRIANGLE"] = "triangle";
    Ionicons["TROPHY"] = "trophy";
    Ionicons["TV"] = "tv";
    Ionicons["UMBRELLA"] = "umbrella";
    Ionicons["VIDEOCAM"] = "videocam";
    Ionicons["VOLUME_HIGH"] = "volume-high";
    Ionicons["VOLUME_LOW"] = "volume-low";
    Ionicons["VOLUME_MEDIUM"] = "volume-medium";
    Ionicons["VOLUME_MUTE"] = "volume-mute";
    Ionicons["VOLUME_OFF"] = "volume-off";
    Ionicons["WALK"] = "walk";
    Ionicons["WALLET"] = "wallet";
    Ionicons["WARNING"] = "warning";
    Ionicons["WATCH"] = "watch";
    Ionicons["WATER"] = "water";
    Ionicons["WIFI"] = "wifi";
    Ionicons["WINE"] = "wine";
    Ionicons["WOMAN"] = "woman";
})(Ionicons || (exports.Ionicons = Ionicons = {}));
